module.exports = {
  pablitosCheckoutPromo: false,
  // Two Guys Glendale: 16"+free 12" and 18"+free 14" pizza specials
  twoGuysGlendalePizzaSpecials: true
}
